require("./sass/app-main.scss");
require("scalajs/web-opt.js")


//////////////////
// WEBPACK FOOTER
// /home/gui/accessible-scala/web/src/main/resources/prod.js
// module id = 2
// module chunks = 0